import { AuthenticationService } from 'data/services';
import { AuthenticationServiceInterface } from 'domain/services';
import { makeRemoteAuthenticationLogin } from 'main/factories/usecases/Authentication/authentication-login-factory';
import { makeRemoteAuthenticationLogout } from 'main/factories/usecases/Authentication/authentication-logout-factory';
import { makeRemoteAuthenticationMe } from 'main/factories/usecases/Authentication/authentication-me-factory';
import { makeRemoteAuthenticationChangePassword } from 'main/factories/usecases/Authentication/authentication-password-reset/authentication-change-password-factory';
import { makeRemoteAuthenticationSendPasswordResetCode } from 'main/factories/usecases/Authentication/authentication-password-reset/authentication-send-code-factory';
import { makeRemoteAuthenticationPasswordResetVerifyCode } from 'main/factories/usecases/Authentication/authentication-password-reset/authentication-verify-code';

export const makeAuthenticationService = (): AuthenticationServiceInterface => {
  return new AuthenticationService(
    makeRemoteAuthenticationMe(),
    makeRemoteAuthenticationLogin(),
    makeRemoteAuthenticationLogout(),
    makeRemoteAuthenticationChangePassword(),
    makeRemoteAuthenticationSendPasswordResetCode(),
    makeRemoteAuthenticationPasswordResetVerifyCode(),
  );
};
